import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export interface WorkspaceRequiredProps {
  onComplete?: () => void;
  message?: string;
}

export const WorkspaceRequired: React.FC<WorkspaceRequiredProps> = ({
  onComplete,
  message = "Your account is authenticated, but not yet linked to an active workspace. Please complete workspace setup to continue.",
}) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-6">
      <div className="p-8 max-w-xl w-full bg-surface-elevated border border-border-subtle rounded-xl shadow-card text-center">
        <ExclamationTriangleIcon className="h-12 w-12 text-status-warning mx-auto mb-4" />
        <h2 className="t-h2 text-text mb-2">Workspace Required</h2>
        <p className="t-body text-text-subtle mb-6">{message}</p>
        {onComplete && (
          <button
            onClick={onComplete}
            className="btn-primary inline-flex items-center justify-center"
          >
            Complete Setup
          </button>
        )}
      </div>
    </div>
  );
};

export default WorkspaceRequired;
